"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderBySessionEnum = exports.EventExpandEnum = exports.SegmentExpandEnum = exports.ProgramSeasonFolderCategoryEnum = exports.SessionExpandEnum = exports.SessionTabEnum = exports.SessionSettingEnum = exports.SegmentOccurrenceTypeEnum = exports.SegmentTypeEnum = exports.EventSortByFieldsEnum = exports.SegmentSortByFieldsEnum = void 0;
var SegmentSortByFieldsEnum;
(function (SegmentSortByFieldsEnum) {
    SegmentSortByFieldsEnum["NAME"] = "name";
    SegmentSortByFieldsEnum["DATE"] = "startDate";
})(SegmentSortByFieldsEnum = exports.SegmentSortByFieldsEnum || (exports.SegmentSortByFieldsEnum = {}));
var EventSortByFieldsEnum;
(function (EventSortByFieldsEnum) {
    EventSortByFieldsEnum["DATE"] = "startDate";
    EventSortByFieldsEnum["TIME"] = "startTime";
})(EventSortByFieldsEnum = exports.EventSortByFieldsEnum || (exports.EventSortByFieldsEnum = {}));
var SegmentTypeEnum;
(function (SegmentTypeEnum) {
    SegmentTypeEnum["SLOT"] = "slot";
    SegmentTypeEnum["DATE"] = "date";
    SegmentTypeEnum["CUSTOM"] = "custom";
})(SegmentTypeEnum = exports.SegmentTypeEnum || (exports.SegmentTypeEnum = {}));
var SegmentOccurrenceTypeEnum;
(function (SegmentOccurrenceTypeEnum) {
    SegmentOccurrenceTypeEnum["WEEK"] = "week";
    SegmentOccurrenceTypeEnum["MONTH"] = "month";
})(SegmentOccurrenceTypeEnum = exports.SegmentOccurrenceTypeEnum || (exports.SegmentOccurrenceTypeEnum = {}));
var SessionSettingEnum;
(function (SessionSettingEnum) {
    SessionSettingEnum["HIDE_EVENT_TIMES"] = "isHideEventTimes";
    SessionSettingEnum["HIDE_SEASON_SCHEDULE"] = "isHideSeasonSchedule";
    SessionSettingEnum["WAITLIST_SETTINGS"] = "waitlistSettings";
})(SessionSettingEnum = exports.SessionSettingEnum || (exports.SessionSettingEnum = {}));
var SessionTabEnum;
(function (SessionTabEnum) {
    SessionTabEnum["DASHBOARD"] = "dashboard";
    SessionTabEnum["INFO"] = "info";
    SessionTabEnum["schedule"] = "schedule";
    SessionTabEnum["PARTICIPANTS_INDIVIDUALS"] = "participants/individuals";
    SessionTabEnum["PARTICIPANTS_GROUPS"] = "participants/groups";
    SessionTabEnum["PARTICIPANTS_WAITLIST"] = "participants/waitlist";
    SessionTabEnum["PRODUCTS"] = "products";
})(SessionTabEnum = exports.SessionTabEnum || (exports.SessionTabEnum = {}));
var SessionExpandEnum;
(function (SessionExpandEnum) {
    SessionExpandEnum["REQUIRED_PRODUCTS"] = "requiredProducts";
    SessionExpandEnum["PRODUCTS"] = "products";
    SessionExpandEnum["PRODUCTS_PRICES"] = "products.prices";
    SessionExpandEnum["PRODUCTS_REQUIRED_PRODUCTS"] = "products.requiredProducts";
    SessionExpandEnum["PRODUCTS_ENTITLEMENT_DISCOUNTS"] = "products.entitlementDiscounts";
})(SessionExpandEnum = exports.SessionExpandEnum || (exports.SessionExpandEnum = {}));
// Default folder categories for ProgramSeason folders/groups
var ProgramSeasonFolderCategoryEnum;
(function (ProgramSeasonFolderCategoryEnum) {
    ProgramSeasonFolderCategoryEnum["TEAM"] = "Team";
    ProgramSeasonFolderCategoryEnum["DIVISION"] = "Division";
    ProgramSeasonFolderCategoryEnum["CONFERENCE"] = "Conference";
    ProgramSeasonFolderCategoryEnum["LEVEL"] = "Level";
    ProgramSeasonFolderCategoryEnum["AGE_GROUP"] = "Age Group";
    ProgramSeasonFolderCategoryEnum["SKILL_LEVEL"] = "Skill Level";
    ProgramSeasonFolderCategoryEnum["GROUP"] = "Group";
})(ProgramSeasonFolderCategoryEnum = exports.ProgramSeasonFolderCategoryEnum || (exports.ProgramSeasonFolderCategoryEnum = {}));
var SegmentExpandEnum;
(function (SegmentExpandEnum) {
    SegmentExpandEnum["RESOURCES"] = "resources";
    SegmentExpandEnum["ACTIVITY_TIMES"] = "activityTimes";
    SegmentExpandEnum["CAPACITY"] = "capacity";
})(SegmentExpandEnum = exports.SegmentExpandEnum || (exports.SegmentExpandEnum = {}));
var EventExpandEnum;
(function (EventExpandEnum) {
    EventExpandEnum["RESOURCES"] = "resources";
    EventExpandEnum["CAPACITY"] = "capacity";
})(EventExpandEnum = exports.EventExpandEnum || (exports.EventExpandEnum = {}));
var OrderBySessionEnum;
(function (OrderBySessionEnum) {
    OrderBySessionEnum["SESSION_NAME"] = "sessionName";
    OrderBySessionEnum["FACILITY_NAME"] = "facilityName";
})(OrderBySessionEnum = exports.OrderBySessionEnum || (exports.OrderBySessionEnum = {}));
//# sourceMappingURL=program-season.enums.js.map